import { ActionReducer, Action } from '@ngrx/store';
import { initialDirectorListState, IDirectorListState } from '../states/director-list.state';
import { EDirectorListActions, SetSearchFilter, SetPagination, SetSort } from '../actions/director-list.actions';

export const directorListReducers: ActionReducer<IDirectorListState, Action<string>> = (
  state = initialDirectorListState,
  action: Action<string>
) => {
  switch (action.type) {
    case EDirectorListActions.SetSearchFilter: {
      const typedAction = action as SetSearchFilter;
      return {
        ...state,
        searchFilter: typedAction.payload,
        currentPage: 1 // Reset to first page when search changes
      };
    }

    case EDirectorListActions.SetPagination: {
      const typedAction = action as SetPagination;
      return {
        ...state,
        currentPage: typedAction.payload.currentPage,
        pageSize: typedAction.payload.pageSize
      };
    }

    case EDirectorListActions.SetSort: {
      const typedAction = action as SetSort;
      return {
        ...state,
        sortBy: typedAction.payload.sortBy,
        ascending: typedAction.payload.ascending
      };
    }

    case EDirectorListActions.ClearFilters: {
      return {
        ...initialDirectorListState
      };
    }

    default:
      return state;
  }
};
